import React from "react";
import { useParams } from "react-router-dom";
import { useGetBlogByIdQuery } from "../../Redux/getApi";

const BlogPage = () => {
  const { id } = useParams();
  const isEditMode = Boolean(id);

  const { data, isLoading, isFetching } = useGetBlogByIdQuery(id, {
    refetchOnFocus: false,
    skip: !isEditMode,
  });

  return (
    <>
      {isLoading || isFetching ? (
        <BlogInnerLoader />
      ) : (
        <div className=" flex flex-col gap-5 items-center min-h-screen justify-center max-w-5xl p-5 mx-auto">
          {data?.blog?.title && (
            <h1 className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem]  text-[1.7rem] w-full text-left ">
              {data?.blog?.title}
            </h1>
          )}
          {data?.blog?.coverImage?.imageUrl && (
            <img
              src={data?.blog?.coverImage?.imageUrl}
              className=" w-full aspect-video object-cover rounded-2xl overflow-hidden"
              alt=""
            />
          )}
          {data?.blog?.content && (
            <div
              className="prose max-w-none w-full prose-img:rounded-xl prose-headings:mb-4 prose-p:mb-2 prose-a:text-[#00643b] hover:prose-a:underline"
              dangerouslySetInnerHTML={{ __html: data.blog.content }}
            />
          )}
        </div>
      )}
    </>
  );
};

const BlogInnerLoader = () => {
  return (
    <div className="animate-pulse max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="w-full mx-auto space-y-4">
        {/* Tag */}
        <div className="w-16 h-6 bg-gray-200 rounded-full" />

        {/* Title */}
        <div className="w-3/4 h-8 bg-gray-300 rounded" />
        <div className="w-1/2 h-8 bg-gray-200 rounded" />

        {/* Meta info (date, author, etc.) */}
        <div className="flex items-center gap-4 mt-3">
          <div className="w-20 h-4 bg-gray-200 rounded" />
          <div className="w-20 h-4 bg-gray-200 rounded" />
        </div>
      </div>
      {/* Featured Image */}
      <div className="w-full h-64 sm:h-80 md:h-[420px] mt-4 bg-gray-200 rounded-2xl mb-8" />

      {/* Blog Title + Meta */}

      {/* Main Content */}
      <div className=" w-full mx-auto mt-10 space-y-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="space-y-2">
            <div className="w-full h-4 bg-gray-200 rounded" />
            <div className="w-5/6 h-4 bg-gray-200 rounded" />
            <div className="w-4/6 h-4 bg-gray-200 rounded" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogPage;
